// extracted by mini-css-extract-plugin
export var bodySections = "_3p-8";
export var gray = "_3p-7";
export var green = "_3p-4";
export var iconContainer = "_3p-9";
export var iconWidgetContainer = "_3p-1";
export var phoneIcon = "_3p-2";
export var red = "_3p-5";
export var statusDot = "_3p-3";
export var widgetContainer = "_3p-0";
export var yellow = "_3p-6";